import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './FinalComponent.css';

export const FinalComponent = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [selectedPost, setSelectedPost] = useState('All');
    const [selectedVibhag, setSelectedVibhag] = useState('All');
    const navigate = useNavigate();

    const categories = ['All', 'General', 'EWS', 'OBC', 'SC', 'ST'];
    
    const postOptions = [
        { hindi: "स्टेनो टाइपिस्ट", english: "Steno Typist" },
        { hindi: "आशुलिपिक", english: "Stenographer" },
        { hindi: "सूचीकार (केटलॉग)", english: "Cataloguer" },
        { hindi: "ओवरसियर", english: "Overseer" },
        { hindi: "प्रयोगशाला सहायक", english: "Laboratory Assistant" },
        { hindi: "लिपिक / कनिष्ठ सहायक", english: "Clerk / Junior Assistant" },
    ];

    const vibhagOptions = [
        { hindi: "मनोविज्ञान विभाग", english: "Psychology Department" },
        { hindi: "सैन्य अध्ययन विभाग", english: "Military Studies Department" },
        { hindi: "गणित विभाग", english: "Mathematics Department" },
        { hindi: "रसायन विज्ञान विभाग", english: "Chemistry Department" },
        { hindi: "भौतिक विज्ञान विभाग", english: "Physics Department" },
        { hindi: "जन्तु विज्ञान विभाग", english: "Zoology Department" },
        { hindi: "वनस्पति विज्ञान विभाग", english: "Botany Department" },
    ];

    useEffect(()=>{
        const login = sessionStorage.getItem("ftoken");
        if (!login){
          alert("Login First");
          navigate("/FolderAdmin");
        }
      });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `${process.env.REACT_APP_ADMIN_API_URL}/fetchData`,{
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("ftoken")}`
            }});

                setData(response.data.rows);
                setFilteredData(response.data.rows);
            } catch (error) {
                console.log(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Filter functionality
    useEffect(() => {
        let results = [...data];
        
        // Apply category filter
        if (selectedCategory !== 'All') {
            results = results.filter((item) => 
                item.category === selectedCategory
            );
        }
        
        // Apply post filter - compare with Hindi values from DB
        if (selectedPost !== 'All') {
            const selectedPostObj = postOptions.find(opt => opt.english === selectedPost);
            const hindiPostValue = selectedPostObj ? selectedPostObj.hindi : selectedPost;
            results = results.filter((item) => 
                item.post === hindiPostValue
            );
        }
        
        // Apply vibhag filter - compare with Hindi values from DB
        if (selectedVibhag !== 'All') {
            const selectedVibhagObj = vibhagOptions.find(opt => opt.english === selectedVibhag);
            const hindiVibhagValue = selectedVibhagObj ? selectedVibhagObj.hindi : selectedVibhag;
            results = results.filter((item) => 
                item.vibhag === hindiVibhagValue
            );
        }
        
        // Apply search filter
        if (searchTerm) {
            results = results.filter((item) =>
                Object.values(item).some(
                    (value) =>
                        value &&
                        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
        
        setFilteredData(results);
    }, [searchTerm, data, selectedCategory, selectedPost, selectedVibhag]);

    const handleRowClick = (item, index) => {
        navigate('/FolderData', { 
            state: { 
                clickedFolder: item.folder,  // folder identifier, NOT index
                allRows: filteredData
            } 
        });
        console.log("aa ekkdam item =>", item.folder);
    };

   

    const handleCategoryFilter = (category) => {
        setSelectedCategory(category);
    };

    const handlePostFilter = (e) => {
        setSelectedPost(e.target.value);
    };

    const handleVibhagFilter = (e) => {
        setSelectedVibhag(e.target.value);
    };

    const clearFilters = () => {
        setSelectedCategory('All');
        setSelectedPost('All');
        setSelectedVibhag('All');
        setSearchTerm('');
    };

    const handleLogout = () => {
        sessionStorage.removeItem("fadmin");
        sessionStorage.removeItem("FAdminLogin");
        sessionStorage.removeItem("ftoken");
        navigate("/FolderLogin");
    };

    if (loading) {
        return (
            <div className="final-component-container">
                <div className="final-component-loading"></div>
            </div>
        );
    }

    return (
        <div className="final-component-container">
            <div className="final-component-header">
                <div className="final-component-header-left">
                    <h2 className="final-component-title">
                        Persons Directory
                    </h2>
                </div>
                <div className="final-component-header-right">
                    <div className="final-component-search">
                        <input
                            type="text"
                            placeholder="🔍 Search by name, mobile, email, folder, or any field..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="final-component-search-input"
                        />
                        {searchTerm && (
                            <span className="final-component-search-count">
                                Found {filteredData.length} of {data.length} records
                            </span>
                        )}
                    </div>
                    <button
                        onClick={handleLogout}
                        className="final-component-logout-btn"
                    >
                        <span className="logout-icon">🚪</span>
                        Log out
                    </button>
                </div>
            </div>

            {/* Filters Section with Dropdowns */}
            <div className="final-component-filters-section">
                {/* Category Filter Buttons */}
                <div className="final-component-filter-group">
                    <label className="final-component-filter-label">Category:</label>
                    <div className="final-component-filter-buttons">
                        {categories.map((category) => (
                            <button
                                key={category}
                                onClick={() => handleCategoryFilter(category)}
                                className={`final-component-filter-btn ${
                                    selectedCategory === category ? 'active' : ''
                                }`}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Post Filter Dropdown */}
                <div className="final-component-filter-group">
                    <label className="final-component-filter-label">Post:</label>
                    <select 
                        value={selectedPost} 
                        onChange={handlePostFilter}
                        className="final-component-filter-dropdown"
                    >
                        <option value="All">All Posts</option>
                        {postOptions.map((post) => (
                            <option key={post.english} value={post.english}>
                                {post.hindi} ({post.english})
                            </option>
                        ))}
                    </select>
                </div>

                {/* Vibhag Filter Dropdown */}
                <div className="final-component-filter-group">
                    <label className="final-component-filter-label">Vibhag:</label>
                    <select 
                        value={selectedVibhag} 
                        onChange={handleVibhagFilter}
                        className="final-component-filter-dropdown"
                    >
                        <option value="All">All Vibhag</option>
                        {vibhagOptions.map((vibhag) => (
                            <option key={vibhag.english} value={vibhag.english}>
                                {vibhag.hindi}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Clear Filters Button */}
                {(selectedCategory !== 'All' || selectedPost !== 'All' || selectedVibhag !== 'All' || searchTerm) && (
                    <button
                        onClick={clearFilters}
                        className="final-component-clear-filters-btn"
                    >
                        Clear All Filters
                    </button>
                )}
            </div>

            {/* Filter Summary */}
            {(selectedCategory !== 'All' || selectedPost !== 'All' || selectedVibhag !== 'All' || searchTerm) && (
                <div className="final-component-filter-summary">
                    <span>Active Filters:</span>
                    {selectedCategory !== 'All' && (
                        <span className="filter-badge">
                            Category: {selectedCategory}
                            <button onClick={() => handleCategoryFilter('All')}>×</button>
                        </span>
                    )}
                    {selectedPost !== 'All' && (
                        <span className="filter-badge">
                            Post: {selectedPost}
                            <button onClick={() => setSelectedPost('All')}>×</button>
                        </span>
                    )}
                    {selectedVibhag !== 'All' && (
                        <span className="filter-badge">
                            Vibhag: {selectedVibhag}
                            <button onClick={() => setSelectedVibhag('All')}>×</button>
                        </span>
                    )}
                    {searchTerm && (
                        <span className="filter-badge">
                            Search: {searchTerm}
                            <button onClick={() => setSearchTerm('')}>×</button>
                        </span>
                    )}
                    <span className="filter-result-count">
                        Showing {filteredData.length} of {data.length} records
                    </span>
                </div>
            )}

            <div className="final-component-table-wrapper">
                <div className="final-component-table-container">
                    <table className="final-component-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Folders</th>
                                <th>Name</th>
                                <th>Father Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Category</th>
                                <th>Gender</th>
                                <th>Post</th>
                                <th>Vibhag</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index
                                ) => (
                                    <tr
                                        key={item.id}
                                        onClick={() => handleRowClick(item, index)}
                                    >
                                        <td>{item.id}</td>
                                        <td>
                                            <span className="final-component-folder-badge">
                                                📁 {item.folder}
                                            </span>
                                        </td>
                                        <td className="final-component-name">
                                            {item.name_english}
                                        </td>
                                        <td>{item.father_name}</td>
                                        <td className="final-component-mobile">
                                            📞 {item.mobile}
                                        </td>
                                        <td className="final-component-email">
                                            ✉️ {item.email}
                                        </td>
                                        <td>
                                            <span className={`category-badge category-${item.category?.toLowerCase()}`}>
                                                {item.category}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={item.gender === 'male' ? 'final-component-gender-male' : 'final-component-gender-female'}>
                                                {item.gender === 'male' ? '👨 Male' : '👩 Female'}
                                            </span>
                                        </td>
                                        <td className="final-component-post">
                                            {item.post}
                                        </td>
                                        <td className="final-component-vibhag">
                                            {item.vibhag}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="final-component-no-data">
                                        {searchTerm || selectedCategory !== 'All' || selectedPost !== 'All' || selectedVibhag !== 'All'
                                            ? 'No matching records found' 
                                            : 'No data available'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};